/**
 *
 * @author arman
 * @since 9/26/17
 *
 */
import React from 'react';
import Subheader from 'material-ui/Subheader';
import gStyles from '../../utility/styles';

/**
 *
 * @param {string} title
 * @param {string} className
 * @param {object} style
 * @constructor
 */
const BoxHeader = ({title, className, style}) => (
  <Subheader className={className || 'box__header'} style={{...gStyles.subheader, ...style}}>
    {title}
  </Subheader>
);

export default BoxHeader;


// WEBPACK FOOTER //
// ./src/screens/shared/box-header.component.js